import { useState, useEffect } from "react";
import EventsEmitter from "events/EventsEmitter";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import { AccessTime } from "@mui/icons-material";

export default function ToolbarTime() {
    const [visible, setVisible] = useState(false);
    const [localeTime, setLocaleTime] = useState("");
    const [localeDate, setLocaleDate] = useState("");
    const toolbarDisplay = visible ? "block" : "none";

    useEffect(() => {
        const onSimDateChange = (eventData: any) => {
            const date: Date = eventData.date;
            const locales: Intl.LocalesArgument = eventData.locales;
            const timeZone: string = eventData.timeZone;

            const timeOptions: Intl.DateTimeFormatOptions = {
                timeZone: timeZone,
                timeZoneName: "short",
            };
            const dateOptions: Intl.DateTimeFormatOptions = {
                timeZone: timeZone,
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
            };

            const localeTime: string = date.toLocaleTimeString(locales, timeOptions);
            const localeDate: string = date.toLocaleDateString(locales, dateOptions);

            setVisible(true);
            setLocaleTime(localeTime);
            setLocaleDate(localeDate);
        };
        EventsEmitter.on("onSimDateChange", onSimDateChange);
        return () => {
            EventsEmitter.removeEventListener("onSimDateChange", onSimDateChange);
        };
    }, []);

    return (
        <div
            id="toolbarTime"
            style={{
                position: "absolute",
                right: 15,
                bottom: 10,
                backgroundColor: "transparent",
                display: toolbarDisplay,
                zIndex: 1700 - 1,
            }}
        >
            <Box
                sx={{
                    width: 280,
                }}
            >
                <AppBar
                    position="static"
                    sx={{
                        borderRadius: 20,
                    }}
                >
                    <Toolbar variant="regular">
                        <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{
                                mr: 2,
                            }}
                        >
                            <AccessTime />
                        </IconButton>
                        <ListItemText primary={localeTime} secondary={localeDate} />
                    </Toolbar>
                </AppBar>
            </Box>
        </div>
    );
}
